<template>
    <div class="widget">

        <div class="panel">
            <div class="panel-heading">
            <span class="badge" v-if="dropins">{{totalParticipants}}</span>

                <h2>Drop-Ins
                    <i 
                    class="clippie fa fa-info-circle"
                    v-tooltip="'Drop-In sessions are common areas to hang out'"></i>
                </h2>
                <div class="toggle-widget" @click="open=!open">
                    <i v-if="open===true" class="fa fa-minus"></i>
                    <i v-else class="fa fa-plus"></i>
                </div>
            </div>
            <div class="panel-body" v-show="open">


               <ul class="class-alerts clearfix path-alert" v-if="dropins">
                <li v-for="dropin in dropins">
                    <a target="_blank" :href="dropin.url">
                        <img src="./../../assets/img/bullhorn.png">
                        <div class="alert-text">
                            <span class="alert-name">
                              {{dropin.name}} ({{dropin.participants.length}})
                          </span>                        

                      </div></a>
                  </li>
              </ul>


          </div>
      </div>

  </div>

</template>


<script>

    import meetings from '../../services/meetings';

    import moment from 'moment';

    export default {    
        data() {
            return {
                open: false,
                dropins: null
            }
        },
        mounted() {
            var self = this;


            this.sockets.subscribe('dropin', (message) => {
                let i = self.dropins.findIndex(function(m){ return m.url.split('/').pop() == message.meetingId});
                if (i > -1) {              
                    // try to find by ID first; if no ID, try to find by username

                    let j = self.dropins[i].participants.findIndex(function(p) { return p.userId == message.userId});
                    
                    if (j === -1) {
                        j = self.dropins[i].participants.findIndex(function(p) { return p.userName == message.userName});
                    }

                    if (message.event === 'joined' && j === -1) {
                        self.dropins[i].participants.push({userId: message.userId, userName: message.userName});
                    } else if (message.event === 'left' && j > -1) {

                        self.dropins[i].participants.splice(j,1);
                    }
                }
            });

            this.getDropins();          

        },
        methods: {
            getDropins() {
                var self = this;
                meetings.getDropins(this).then(function(response) {
                    self.dropins = response.data.dropins;
                });
            },
        },
        computed: {
            totalParticipants() {
                if (!this.dropins) return;
                let total = 0;
                this.dropins.forEach(function(d){
                    total += d.participants.length;
                });
                return total;
            } 
        }

    }
</script>

<style scoped>
.panel-body p {
    text-align:center;
    padding-top:2rem;
}
.class-alerts {
    margin-top:2rem;
    margin-bottom: 1rem;
}
.path-alert {
    padding-top: 0!important;
    padding-bottom:0rem;

}
.panel-body > ul:last-child {
    padding-bottom:2rem;
}
a {
    color:inherit;
}
ul {
    clear:both;
    padding-bottom:2rem;
    padding-top:1.5rem;
}
li {
    padding: 1rem 1rem 1rem 2rem;
    clear:both;
}
h5 {
    margin-bottom:0;
}
img, .alert-text {
 display:block;
 float:left;
}
.alert-text {
    padding-left:1rem;
    max-width: 80%;
}
.alert-name {
    color:white;
}
</style>


// WEBPACK FOOTER //
// DropIns.vue?09963d39